/*
  MacShack product add-ons (sections/ms-product-addons.liquid).
  MacBook pages: skin studio + "Make it yours" row in the buy box.
  Other pages: "Complete your setup" cards found via search / recommendations.
*/
(function () {
  if (window.__msxInit) return;
  window.__msxInit = true;

  var root, prefix = 'R ';
  function money(cents) {
    var n = Math.round(cents) / 100, whole = Math.floor(n), frac = Math.round((n - whole) * 100);
    var s = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (frac) s += '.' + (frac < 10 ? '0' : '') + frac;
    return prefix + s;
  }
  function main() { return document.querySelector('ms-product'); }
  function reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* Add items to the cart and refresh / open the theme's cart drawer. */
  function addToCart(items, btn) {
    var minicart = document.querySelector('mini-cart');
    var body = { items: items };
    if (minicart && minicart.getSectionsToRender) {
      body.sections = minicart.getSectionsToRender().map(function (s) { return s.section; });
      body.sections_url = window.location.pathname;
    }
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Something went wrong. Please try again.');
        if (window.themeSettings && window.themeSettings.redirectToCart) { window.location.href = '/cart'; return res; }
        if (minicart && res.sections) {
          try { minicart.renderContents(res); if (!document.body.classList.contains('template-cart')) minicart.open(btn); } catch (e) { /* drawer not available; status line still confirms */ }
        }
        document.dispatchEvent(new CustomEvent('cart:item-add', { detail: { items: res.items || [res], context: 'MsAddons' } }));
        return res;
      });
  }

  function busy(btn, on) {
    btn.classList.toggle('is-loading', on);
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }

  /* ---------------- Skins ---------------- */
  function initSkins(sec) {
    var skins;
    try { skins = JSON.parse(sec.querySelector('[data-skins]').textContent); } catch (e) { return; }
    if (!skins.length) return;

    var stage = sec.querySelector('[data-stage]');
    var nameEl = sec.querySelector('[data-skin-name]');
    var sw = sec.querySelector('[data-swatches]');
    var views = sec.querySelector('[data-views]');
    var fitting = sec.querySelector('[data-fitting]');
    var both = sec.querySelector('[data-add-both]');
    var only = sec.querySelector('[data-add-skin]');
    var status = sec.querySelector('[data-status]');
    var cur = 0, view = 'flat', inBag = {}, expanded = false;
    var SHOW = 9;

    function fitCents() { return fitting && fitting.checked ? parseInt(fitting.getAttribute('data-price'), 10) || 0 : 0; }

    function drawSwatches() {
      sw.innerHTML = '';
      var limit = expanded ? skins.length : Math.min(SHOW, skins.length);
      if (!expanded && skins.length === SHOW + 1) limit = skins.length;
      skins.slice(0, limit).forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'msx-sw';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', i === cur ? 'true' : 'false');
        b.setAttribute('aria-label', s.name);
        b.title = s.name;
        b.tabIndex = i === cur ? 0 : -1;
        b.innerHTML = '<img src="' + s.swatch + '" alt="" width="80" height="80" loading="lazy">';
        b.addEventListener('click', function () { pick(i, true); });
        b.addEventListener('mouseenter', function () { preload(s); });
        sw.appendChild(b);
      });
      if (limit < skins.length) {
        var m = document.createElement('button');
        m.type = 'button';
        m.className = 'msx-more';
        m.innerHTML = '+' + (skins.length - limit) + '<span class="ms-vh"> more designs</span>';
        m.addEventListener('click', function () { expanded = true; drawSwatches(); var b = sw.children[limit]; if (b) b.focus(); });
        sw.appendChild(m);
      }
    }

    sw.addEventListener('keydown', function (e) {
      var k = e.key, n = null;
      if (k === 'ArrowRight' || k === 'ArrowDown') n = cur + 1;
      if (k === 'ArrowLeft' || k === 'ArrowUp') n = cur - 1;
      if (n === null) return;
      e.preventDefault();
      n = (n + skins.length) % skins.length;
      if (n >= SHOW && !expanded) { expanded = true; drawSwatches(); }
      pick(n, true);
      var b = sw.querySelectorAll('.msx-sw')[n];
      if (b) b.focus();
    });

    var cache = {};
    function preload(s) {
      [s.flat, s.photo].forEach(function (u) { if (u && !cache[u]) { cache[u] = new Image(); cache[u].src = u; } });
    }

    function drawStage() {
      var s = skins[cur];
      var hasPhoto = !!s.photo;
      if (views) views.hidden = !hasPhoto;
      var v = hasPhoto ? view : 'flat';
      stage.classList.toggle('is-photo', v === 'photo');
      stage.src = v === 'photo' ? s.photo : s.flat;
      stage.alt = s.name + ' MacShack skin' + (v === 'photo' ? ' on a MacBook' : '');
    }

    function pick(i, user) {
      cur = i;
      var s = skins[i];
      nameEl.textContent = s.name;
      Array.prototype.forEach.call(sw.querySelectorAll('.msx-sw'), function (b, k) {
        b.setAttribute('aria-checked', k === i ? 'true' : 'false');
        b.tabIndex = k === i ? 0 : -1;
      });
      drawStage();
      if (user) status.textContent = '';
      labels();
      syncRow();
    }

    if (views) {
      views.querySelectorAll('[data-view]').forEach(function (b) {
        b.addEventListener('click', function () {
          view = b.getAttribute('data-view');
          views.querySelectorAll('[data-view]').forEach(function (o) {
            var on = o === b;
            o.classList.toggle('is-on', on);
            o.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          drawStage();
        });
      });
    }

    /* Button labels follow the main product state (variant, coverage, quantity). */
    function labels() {
      var m = main();
      var skin = skins[cur].price, fit = fitCents();
      // Re-read for the variant shown now, so a variant switch or a removal from the bag is reflected.
      var macInCart = !!(m && m.variant && inBag[m.variant.id]);
      var canBoth = m && m.variant && m.variant.available && !(m.data && m.data.isQuote) && !macInCart;
      both.hidden = !canBoth;
      if (canBoth) {
        both.querySelector('[data-both-label]').textContent = 'Add MacBook + skin · ' + money(m.total() + skin + fit);
        only.querySelector('[data-skin-label]').textContent = (fit ? 'Add the skin and fitting only · ' : 'Add the skin only · ') + money(skin + fit);
        only.className = 'msp-cta2';
      } else {
        only.querySelector('[data-skin-label]').textContent = (fit ? 'Add skin + fitting · ' : 'Add skin · ') + money(skin + fit);
        only.className = 'msp-cta';
      }
    }

    function itemsFor(withMac) {
      var m = main(), items = [];
      var s = skins[cur];
      if (withMac && m) {
        items.push({ id: m.variant.id, quantity: m.qty() });
        if (m.coverage === 'ext' && m.tier) items.push({ id: m.tier.id, quantity: m.qty(), properties: { _for: String(m.variant.id) } });
      }
      var forId = m && m.variant ? String(m.variant.id) : '';
      items.push(forId ? { id: s.id, quantity: 1, properties: { _for: forId } } : { id: s.id, quantity: 1 });
      if (fitCents()) {
        var props = {};
        var title = m && m.data && m.data.title;
        props['Skin'] = s.name;
        if (title) props['MacBook'] = title;
        if (forId) props._for = forId;
        items.push({ id: parseInt(fitting.value, 10), quantity: 1, properties: props });
      }
      return items;
    }

    function go(btn, withMac) {
      if (btn.classList.contains('is-loading')) return;
      status.textContent = '';
      status.classList.remove('is-error');
      busy(btn, true);
      addToCart(itemsFor(withMac), btn)
        .then(function () {
          var s = skins[cur];
          status.textContent = withMac ? 'Added your MacBook and the ' + s.name + ' skin to your bag.' : 'Added the ' + s.name + ' skin to your bag.';
          if (withMac) { var mm = main(); if (mm && mm.variant) inBag[mm.variant.id] = true; labels(); }
        })
        .catch(function (e) {
          status.classList.add('is-error');
          status.textContent = e.message || 'Something went wrong. Please try again.';
        })
        .finally(function () { busy(btn, false); });
    }

    both.addEventListener('click', function () { go(both, true); });
    only.addEventListener('click', function () { go(only, false); });
    if (fitting) fitting.addEventListener('change', labels);

    /* Keep totals in step with the buy box. */
    var mp = main();
    if (mp) {
      ['change', 'click'].forEach(function (ev) {
        mp.addEventListener(ev, function () { setTimeout(labels, 0); });
      });
    }

    /* Is this Mac already in the bag? Then only the skin is offered.
       Checked on load, after any bag change (add, remove, quantity, from the drawer or the
       product page), and when the page is shown again (back button / returning to the tab). */
    var checking = null;
    function checkCart() {
      if (checking) return checking;
      checking = fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          inBag = {};
          (c.items || []).forEach(function (it) { inBag[it.variant_id] = true; });
          labels();
        })
        .catch(function () {})
        .finally(function () { checking = null; });
      return checking;
    }
    document.addEventListener('cart:item-add', function (e) {
      if (e.detail && e.detail.context === 'MainProductPage') { var mm = main(); if (mm && mm.variant) inBag[mm.variant.id] = true; labels(); }
      setTimeout(checkCart, 400);
    });
    ['cart:item-remove', 'cart:item-quantity-update', 'cart:updated'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(checkCart, 400); });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) checkCart(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') checkCart(); });

    /* Buy-box row: "Make it yours" above trade-in. */
    var row;
    function syncRow() {
      if (!row) return;
      var img = row.querySelector('img');
      if (img) img.src = skins[cur].swatch;
    }
    function injectRow() {
      var m = main();
      var rows = m && m.querySelector('.msp-rows');
      if (!rows || rows.querySelector('[data-msx-row]')) return;
      row = document.createElement('button');
      row.type = 'button';
      row.className = 'msp-row msx-row';
      row.setAttribute('data-msx-row', '');
      row.innerHTML =
        '<span class="msp-ico msx-row__ico" aria-hidden="true"><img src="' + skins[cur].swatch + '" alt="" width="36" height="36"></span>' +
        '<span class="msp-row__t">Make it yours<small>' + skins.length + ' MacShack skins · ' + money(skins[0].price) + '</small></span>' +
        '<span class="msp-row__end">Choose ›</span>';
      row.addEventListener('click', function () {
        sec.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
        setTimeout(function () { var b = sw.querySelector('[aria-checked="true"]'); if (b) b.focus({ preventScroll: true }); }, reduced() ? 0 : 600);
      });
      rows.insertBefore(row, rows.firstChild);
    }

    drawSwatches();
    pick(0, false);
    injectRow();
    checkCart();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en, obs) {
        if (!en[0].isIntersecting) return;
        obs.disconnect();
        skins.slice(0, 6).forEach(preload);
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(sec);
    }
  }

  /* ---------------- Complete your setup ---------------- */
  function initSetup(sec) {
    var list = sec.querySelector('[data-setup-list]');
    var status = sec.querySelector('[data-setup-status]');
    var model = (root.getAttribute('data-model') || '').trim();
    var family = (root.getAttribute('data-family') || '').trim();
    var pid = root.getAttribute('data-pid');
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var recoUrl = root.getAttribute('data-reco-url') || '/recommendations/products';
    var MAX = 4, seen = {}, found = [];
    var exclude = (root.getAttribute('data-exclude') || '').split(',');
    var SID = 'ms-setup-results';

    function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    /* "iPhone 15" must not match "iPhone 15 Pro" (unless the model itself is a Pro). */
    function fits(title, m) {
      if (!m) return true;
      var lower = m.toLowerCase();
      var extra = ['pro', 'plus', 'max', 'mini', 'air', 'ultra', 'se'].filter(function (w) { return lower.split(/\s+/).indexOf(w) === -1; });
      var re = new RegExp(esc(m).replace(/\s+/g, '\\s+') + (extra.length ? '(?!\\s*(?:' + extra.join('|') + ')\\b)' : '') + '(?![0-9])', 'ig');
      return re.test(title);
    }

    /* Items made for one specific device ("iPhone 12 case", "MacBook Pro 14-inch shell") only show when they fit this one. */
    var SPECIFIC = /(macbook\s*(air|pro|neo)?\s*\d{2}|iphone\s*\d{1,2}|ipad\s*(air|pro|mini)?\s*\d|watch\s*(series|ultra|se)\s*\d)/i;
    function sensible(t) { return !SPECIFIC.test(t) || (model && fits(t, model)); }

    function load(url) {
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('[data-setup-item]'));
        })
        .catch(function () { return []; });
    }

    function take(items, why, filter) {
      items.forEach(function (li) {
        if (found.length >= MAX) return;
        var id = li.getAttribute('data-id');
        if (!id || seen[id] || exclude.indexOf(id) !== -1) return;
        if (filter && !filter(li.getAttribute('data-title') || '')) return;
        seen[id] = true;
        var w = li.querySelector('[data-why]');
        if (w) w.textContent = why;
        found.push(li);
      });
    }

    function q(term) { return searchUrl + '?q=' + encodeURIComponent(term) + '&type=product&options[prefix]=last&section_id=' + SID; }
    function reco(intent) { return recoUrl + '?product_id=' + pid + '&limit=10&intent=' + intent + '&section_id=' + SID; }

    var steps = [];
    if (model) steps.push(function () { return load(q(model)).then(function (it) { take(it, 'Fits ' + model, function (t) { return fits(t, model); }); }); });
    if (family && family !== model) steps.push(function () { return load(q(family)).then(function (it) { take(it, 'For ' + family, function (t) { return t.toLowerCase().indexOf(family.toLowerCase()) !== -1 && sensible(t); }); }); });
    steps.push(function () { return load(reco('complementary')).then(function (it) { take(it, 'Goes with this', sensible); }); });
    steps.push(function () { return load(reco('related')).then(function (it) { take(it, 'Popular add-on', sensible); }); });

    function run(i) {
      if (i >= steps.length || found.length >= MAX) return Promise.resolve();
      return steps[i]().then(function () { return run(i + 1); });
    }

    /* "✓ Added" mirrors the bag: when the item leaves the bag, the card can add it again. */
    function syncAdded() {
      if (!list.isConnected || !list.querySelector('[data-quick-add]')) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var ids = {};
          (c.items || []).forEach(function (it) { ids[it.variant_id] = true; });
          list.querySelectorAll('[data-quick-add]').forEach(function (b) {
            if (b.classList.contains('is-loading')) return;
            var on = !!ids[b.getAttribute('data-quick-add')];
            var lbl = b.querySelector('span');
            b.classList.toggle('is-on', on);
            if (lbl) lbl.textContent = on ? '✓ Added' : (b.getAttribute('data-label') || '+ Add');
          });
        })
        .catch(function () {});
    }
    ['cart:item-remove', 'cart:item-quantity-update', 'cart:updated'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(syncAdded, 300); });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) syncAdded(); });

    function start() {
      run(0).then(function () {
        if (!found.length) return;
        found.forEach(function (li) { list.appendChild(document.importNode(li, true)); });
        sec.hidden = false;
        list.querySelectorAll('[data-quick-add]').forEach(function (b) {
          var lbl = b.querySelector('span');
          if (lbl && !b.hasAttribute('data-label')) b.setAttribute('data-label', lbl.textContent);
          b.addEventListener('click', function () {
            if (b.classList.contains('is-loading') || b.classList.contains('is-on')) return;
            var card = b.closest('[data-setup-item]');
            var name = card ? card.querySelector('.msx-card__name').textContent.trim() : 'Item';
            busy(b, true);
            status.classList.remove('is-error');
            addToCart([{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }], b)
              .then(function () {
                b.classList.add('is-on');
                b.querySelector('span').textContent = '✓ Added';
                status.textContent = 'Added ' + name + ' to your bag.';
              })
              .catch(function (e) {
                status.classList.add('is-error');
                status.textContent = e.message;
              })
              .finally(function () { busy(b, false); });
          });
        });
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en, obs) {
        if (!en[0].isIntersecting) return;
        obs.disconnect();
        start();
      }, { rootMargin: '0px 0px 800px 0px' });
      io.observe(root);
    } else {
      start();
    }
  }

  function init() {
    root = document.querySelector('[data-msx]');
    if (!root) return;
    prefix = root.getAttribute('data-money-prefix') || 'R ';
    var skins = root.querySelector('#msx-skins');
    if (skins) {
      if (customElements.get('ms-product')) initSkins(skins);
      else customElements.whenDefined('ms-product').then(function () { initSkins(skins); });
    }
    var setup = root.querySelector('[data-setup]');
    if (setup) initSetup(setup);
  }

  // The bag page swaps "Complete your setup" when the main device in the bag changes.
  window.msAddonsInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
